import React from 'react';
import { Button } from '../../Atoms';
import { Input } from '../../Molecules';
import { SelectOrganism } from '../../Organisms';
function TemplateSimulateurRembourcementScreen1(props) {
    return (
        <>
            <div className='first-line-simulateur-remboursement' >

                <SelectOrganism
                    placeholder=' '
                    option={props.benefList}
                    inputLabel='Bénéficiaire du soin'
                    classNameInput='select-simulateur-remboursement'
                    classNameIcon='icon-select-simulateur-remboursement'
                    iconSize={8}
                    classNameSelectMenu='input-select-simulateur-remboursement'
                    classNameOptionContainer='select-option-container-simulateur-remboursement'
                    classNameSelectedOption='selected-option-container-simulateur-remboursement'
                    showModalView={false}
                    value={props.selectedBenef.text}
                    onChange={props.onChangeBenef}
                />
                <div className='select-margin-simulateur-remboursement' >
                    <SelectOrganism
                        placeholder=' '
                        option={props.actesList}
                        inputLabel='Liste des actes'
                        classNameInput='select-simulateur-remboursement'
                        classNameIcon='icon-select-simulateur-remboursement'
                        iconSize={8}
                        classNameSelectMenu='input-select-simulateur-remboursement'
                        classNameOptionContainer='select-option-container-simulateur-remboursement'
                        classNameSelectedOption='selected-option-container-simulateur-remboursement'
                        showModalView={false}
                        renderItem={props.renderListActesOptions}
                        value={props.selectedActesListItem.text}
                        onChange={props.onChangeSelectedActesListItem}
                    />
                </div>
                <div className='select-margin-simulateur-remboursement' >
                    <SelectOrganism
                        placeholder=' '
                        option={props.actesSoinsList}
                        inputLabel='Actes'
                        classNameInput='select-simulateur-remboursement'
                        classNameIcon='icon-select-simulateur-remboursement'
                        iconSize={8}
                        classNameSelectMenu='input-select-simulateur-remboursement'
                        classNameOptionContainer='select-option-container-simulateur-remboursement'
                        classNameSelectedOption='selected-option-container-simulateur-remboursement'
                        showModalView={false}
                        value={props.selectedActes.text}
                        onChange={props.onChangeActes}
                    />
                </div>
            </div>
            <div className="last-line-simulateur-remboursement" >
                <Input
                    inputLabel='Commentaire (facultatif)'
                    placeholder=''
                    className='commentaire-input-simulateur-remboursement'
                />
            </div>
            <div className='btn-next-container-simulateur-remboursement'>
                <Button
                    text='Suivant'
                    className={'btn-next-simulateur-remboursement'}
                    onClick={() => props.nextStep(1)}
                />
            </div>
        </>

    );
}

export default TemplateSimulateurRembourcementScreen1;
